module.exports = "<div>\r\n    <select class=\"form-control\" required [(ngModel)]=\"selected_id\" style=\"width: 25rem;\">\r\n        <option value=\"null\" *ngIf=\"companylist.length>1\">全会社対象</option>\r\n        <option *ngFor=\"let l of companylist\" [value]=\"l.id\">{{l.t_company_name_short}}：{{l.t_company_name}}\r\n        </option>\r\n    </select>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/a0106-mail/a-company-list.component.html
// module id = ./src/app/a0106-mail/a-company-list.component.html
// module chunks = main